import React from "react";
import SelectOption from "./components/SelectOption";
import SelectOptionOther from "./components/SelectOptionOther";

const cosmeticTypeOptions = [
  {
    value: "スキンケア スカルプケア",
    label: (
      <div className="w-full h-full flex flex-col items-center justify-center text-[10px] leading-3">
        <p>スキンケア</p>
        <p>スカルプケア</p>
      </div>
    ),
  },
  {
    value: "ボディケア",
    label: "ボディケア",
  },
  {
    value: "メイクアップ",
    label: "メイクアップ",
  },
  {
    value: "ヘアケア",
    label: "ヘアケア",
  },
  {
    value: "原料",
    label: "原料",
  },
];

function SelectCosmeticType({
  selectedValue,
  onSelect,
  isReadonly,
  screenWidth,
}) {
  return (
    <div className="w-full h-full border border-solid border-[#B3B3B3] bg-white rounded-[10px]">
      <div className="w-full h-full grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 items-center justify-center gap-2.5 py-2 px-2 lg:px-[30px]">
        <SelectOption
          label={cosmeticTypeOptions[0].label}
          value={cosmeticTypeOptions[0].value}
          onSelect={onSelect}
          isSelected={selectedValue === cosmeticTypeOptions[0].value}
          isReadonly={isReadonly}
        />
        <SelectOption
          label={cosmeticTypeOptions[1].label}
          value={cosmeticTypeOptions[1].value}
          onSelect={onSelect}
          isSelected={selectedValue === cosmeticTypeOptions[1].value}
          isReadonly={isReadonly}
        />
        <SelectOption
          label={cosmeticTypeOptions[2].label}
          value={cosmeticTypeOptions[2].value}
          onSelect={onSelect}
          isSelected={selectedValue === cosmeticTypeOptions[2].value}
          isReadonly={isReadonly}
        />
        {screenWidth >= 1024 && <div className=" h-0"></div>}
        <SelectOption
          label={cosmeticTypeOptions[3].label}
          value={cosmeticTypeOptions[3].value}
          onSelect={onSelect}
          isSelected={selectedValue === cosmeticTypeOptions[3].value}
          isReadonly={isReadonly}
        />
        <SelectOption
          label={cosmeticTypeOptions[4].label}
          value={cosmeticTypeOptions[4].value}
          onSelect={onSelect}
          isSelected={selectedValue === cosmeticTypeOptions[4].value}
          isReadonly={isReadonly}
        />
         {screenWidth < 1024 && <div className=" h-0"></div>}
        <SelectOptionOther
          selectedValue={selectedValue}
          onSelect={onSelect}
          isReadonly={isReadonly}
          otherPrefix="その他"
        />
      </div>
    </div>
  );
}

export default SelectCosmeticType;
